module.exports = require("@ungap/structured-clone");